import {
    PAGE_LAYOUTS_CREATE,
    PAGE_LAYOUTS_CREATE_COMPLETED,
    PAGE_LAYOUTS_DELETE,
    PAGE_LAYOUTS_DELETE_COMPLETED,
    PAGE_LAYOUTS_COPY,
    PAGE_LAYOUTS_COPY_COMPLETED,
    PAGE_LAYOUTS_UPDATE,
    PAGE_LAYOUTS_UPDATE_COMPLETED,
    PAGE_LAYOUTS_PAGE_CREATE,
} from "constants/action-types";

export const createPageLayout = (payload) => ({
    payload,
    type: PAGE_LAYOUTS_CREATE,
});

export const createPageLayoutSuccess = (payload, meta) => ({
    meta,
    payload,
    type: PAGE_LAYOUTS_CREATE_COMPLETED,
});

export const createPageLayoutError = (payload) => ({
    error: true,
    payload,
    type: PAGE_LAYOUTS_CREATE_COMPLETED,
});

export const deletePageLayout = (pageId, layoutId) => ({
    payload: { pageId, layoutId },
    type: PAGE_LAYOUTS_DELETE,
});

export const deletePageLayoutSuccess = (payload) => ({
    payload,
    type: PAGE_LAYOUTS_DELETE_COMPLETED,
});

export const deletePageLayoutError = (payload) => ({
    error: true,
    payload,
    type: PAGE_LAYOUTS_DELETE_COMPLETED,
});

export const copyPageLayout = (pageId, layoutId, name, description) => ({
    payload: { pageId, layoutId, name, description },
    type: PAGE_LAYOUTS_COPY,
});

export const copyPageLayoutSuccess = (payload) => ({
    payload,
    type: PAGE_LAYOUTS_COPY_COMPLETED,
});

export const copyPageLayoutError = (payload) => ({
    error: true,
    payload,
    type: PAGE_LAYOUTS_COPY_COMPLETED,
});

export const updatePageLayout = (payload) => ({
    payload,
    type: PAGE_LAYOUTS_UPDATE,
});

export const updatePageLayoutSuccess = (payload) => ({
    payload,
    type: PAGE_LAYOUTS_UPDATE_COMPLETED,
});

export const updatePageLayoutError = (payload) => ({
    error: true,
    payload,
    type: PAGE_LAYOUTS_UPDATE_COMPLETED,
});

export const createPage = (payload) => ({
    payload,
    type: PAGE_LAYOUTS_PAGE_CREATE,
});
